import React, { useState, useEffect } from 'react';
import '../CSS/Global.css';
import { useSidebar } from '../SidebarContext';
import Header from './Header';
import Sidebar from './SideBar';

const ContactTable = () => {
    const { isSidebarOpen } = useSidebar();

    const [searchQuery, setSearchQuery] = useState('');
    const [employees, setEmployees] = useState([
        {
            email: 'rahul.sharma@example.in',
            name: 'Mr. Rahul Sharma',
            number: '9876543210',
            message: 'I am interested in the new project management tools.' // Message content
        },
        {
            email: 'priya.verma@example.in',
            name: 'Ms. Priya Verma',
            number: '9123456789',
            message: 'Looking for opportunities in software engineering.' // Message content
        },
        {
            email: 'amit.patel@example.in',
            name: 'Mr. Amit Patel',
            number: '9988776655',
            message: 'I have experience in UI/UX and would love to discuss projects.' // Message content
        },
        {
            email: 'anita.nair@example.in',
            name: 'Mrs. Anita Nair',
            number: '9012345678',
            message: 'HR Manager with expertise in talent acquisition.' // Message content
        },
        {
            email: 'rohan.das@example.in',
            name: 'Mr. Rohan Das',
            number: '9345678123',
            message: 'I lead marketing strategies and business development.' // Message content
        },
        {
            email: 'neha.jain@example.in',
            name: 'Ms. Neha Jain',
            number: '9876501234',
            message: 'Content creation and writing for digital platforms.' // Message content
        },
        {
            email: 'manoj.kumar@example.in',
            name: 'Mr. Manoj Kumar',
            number: '8765432109',
            message: 'Data analysis experience with predictive modeling.' // Message content
        },
        {
            email: 'swati.mishra@example.in',
            name: 'Ms. Swati Mishra',
            number: '8123456789',
            message: 'Business analysis and process optimization expert.' // Message content
        },
        {
            email: 'rajiv.rathi@example.in',
            name: 'Mr. Rajiv Rathi',
            number: '7890123456',
            message: 'Product management experience in tech startups.' // Message content
        },
        {
            email: 'pooja.kapoor@example.in',
            name: 'Ms. Pooja Kapoor',
            number: '8765012345',
            message: 'Finance executive specializing in corporate finance.' // Message content
        }
    ]);


    const [filteredEmployees, setFilteredEmployees] = useState(employees);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    useEffect(() => {
        const filtered = employees.filter((employee) =>
            Object.values(employee).some((value) =>
                String(value).toLowerCase().includes(searchQuery.toLowerCase())
            )
        );
        setFilteredEmployees(filtered);
        setCurrentPage(1);
    }, [searchQuery, employees]);

    const totalPages = Math.ceil(filteredEmployees.length / itemsPerPage);
    const currentData = filteredEmployees.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    const handleSearch = (e) => setSearchQuery(e.target.value);
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const handleDelete = (email) => {
        const updatedEmployees = employees.filter(employee => employee.email !== email);
        setEmployees(updatedEmployees);
    };

    useEffect(() => {
        const fetchContacts = async () => {
            try {
                const response = await fetch("https://backend.impactjournal.co.in/contactus");
                const data = await response.json();
                setEmployees(data);
            } catch (error) {
                console.error("Failed to fetch contacts", error);
            }
        };

        fetchContacts();
    }, []);


    return (
        <>
            <Header />
            <Sidebar />
            <div className={`open-close ${isSidebarOpen ? 'open' : 'closed'}`}>
                <h1 className="dashboard-title">All users</h1>

                <div className="filter-search">
                    <div className="filter-search-input">
                        <input
                            type="search"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearch}
                        />
                        <i className="fa fa-search"></i>
                    </div>
                </div>

                <div className="customer-table">
                    <table>
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Phone Number</th>
                                <th>Email</th>
                                <th>Message</th> {/* Assuming Message refers to the address */}
                            </tr>
                        </thead>
                        <tbody>
                            {currentData.length > 0 ? (
                                currentData.map((employee, index) => (
                                    <tr key={index}>
                                        <td>{employee.name}</td>
                                        <td>{employee.number}</td>
                                        <td>{employee.email}</td>
                                        <td>{employee.message}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="4" style={{ textAlign: 'center' }}>No users found.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                <div className="pagination">
                    <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
                        <i class="fa-solid fa-chevron-left"></i><i class="fa-solid fa-chevron-left"></i>
                    </button>



                    <button className="active">
                        {currentPage}
                    </button>

                    {currentPage < totalPages && (
                        <button onClick={() => paginate(currentPage + 1)}>
                            {currentPage + 1}
                        </button>
                    )}

                    {currentPage + 1 < totalPages && (
                        <span className="dots">...</span>
                    )}

                    {currentPage !== totalPages && (
                        <button onClick={() => paginate(totalPages)}>
                            {totalPages}
                        </button>
                    )}

                    <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages}>
                        <i class="fa-solid fa-chevron-right"></i><i class="fa-solid fa-chevron-right"></i>
                    </button>
                </div>
            </div>
        </>
    );
};

export default ContactTable;
